import { render, staticRenderFns } from "./create-person.vue?vue&type=template&id=31ba90f9&scoped=true"
import script from "./create-person.vue?vue&type=script&lang=ts"
export * from "./create-person.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba90f9",
  null
  
)

export default component.exports